import {
    faClockRotateLeft,
    faDownload,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InputGroup, InputGroupAddon } from 'reactstrap';
import './FileSelector.scss';
import React, { ChangeEvent } from 'react';
import { Input } from '@availity/form';
import createNotification from '../../utils/createNotification';
interface TemporaryFileSelectorProps {
    disabled: boolean;
    file: File;
    setFile: (file: File) => void;
    fileName: string;
    downloadFile(): void;
    extension?: string;
    setIsDocumentsHistoryPopupVisible(isVisible: boolean): void;
    oldDocumentDetailsList?: Array<string>;
}
export const FileSelector = (props: TemporaryFileSelectorProps) => {
    const changeFileHandler = (event: ChangeEvent<HTMLInputElement>) => {
        if (props.extension) {
            const allowedExtensions = props.extension
                .split(',')
                .map((ext) => ext.trim());
            const fileExtension = event.target.files[0]?.name.split('.').pop();
            if (!allowedExtensions.includes(`.${fileExtension}`)) {
                createNotification(
                    `Please select a file with one of the following extensions: ${props.extension}.`,
                    'error'
                );
                return;
            }
        }
        const newFile = event.target.files[0];
        if (newFile) {
            props.setFile(newFile);
        }
    };

    const downloadNewSelectedFile = () => {
        if (props.file) {
            const fr = new FileReader();
            fr.readAsDataURL(props.file);
            const blob = new Blob([props.file], { type: props.file.type });
            const objectURL = window.URL.createObjectURL(blob);
            var link = document.createElement('a');
            link.href = objectURL;
            link.download = props.file.name;
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
    };

    return (
        <div
            className={`${'file-selector'} ${
                props.disabled ? 'file-select-disabled' : ''
            }`}>
            <div className="header-container">
                <label
                    className="link-button"
                    htmlFor="upload-file"
                    aria-disabled={props.disabled}>
                    Select File
                </label>
                <input
                    accept={props.extension}
                    hidden={true}
                    type="file"
                    name="file"
                    id="upload-file"
                    className="upload-file-input"
                    disabled={props.disabled}
                    onChange={changeFileHandler}
                />
                {props.oldDocumentDetailsList?.length > 0 && (
                    <FontAwesomeIcon
                        style={{ cursor: 'pointer', marginLeft: '3px' }}
                        onClick={() =>
                            props.setIsDocumentsHistoryPopupVisible(true)
                        }
                        icon={faClockRotateLeft}
                    />
                )}
            </div>

            {props.fileName ? (
                <InputGroup>
                    <Input
                        type="text"
                        name="sourceFile"
                        disabled={true}
                        className="form-control file-display"
                    />
                    <InputGroupAddon addonType="append">
                        <div className="input-group-text file-addon no-right-padding">
                            <FontAwesomeIcon
                                className="download-icon"
                                icon={faDownload}
                                onClick={() => {
                                    props.file
                                        ? downloadNewSelectedFile()
                                        : props.downloadFile();
                                }}></FontAwesomeIcon>
                        </div>
                    </InputGroupAddon>
                </InputGroup>
            ) : (
                <></>
            )}
        </div>
    );
};
